import React from 'react';
import { FiCheck, FiX, FiAlertTriangle } from 'react-icons/fi';

const Toast = ({ message, type = 'success', onClose }) => {
  if (!message) return null;
  const icons = { success: <FiCheck />, error: <FiX />, warning: <FiAlertTriangle /> };
  return (
    <div className={`toast ${type}`}>
      {icons[type]}
      <span>{message}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', marginLeft: 'auto', padding: 2, display: 'flex' }}>
        <FiX size={14} />
      </button>
    </div>
  );
};

export default Toast;
